export default "__VITE_ASSET__aGDhsZ0e__"